import { InterAccountTransferErrors } from "../../../../Wrap/Validation/Errors/Transfer/InterAccount/InterAccountTransferErrors";
export const stepName = {
    stepOne: "Move investments to new owner",
    stepTwo: "Review and submit",
};
export const enum TransferReason {
    NotSpecified = 0,
    Death = 1,
    Divorce = 2,
    DuplicateAccount = 3,
    Other = 4,
}

export const ReasonMap = {
    [TransferReason.NotSpecified]: "",
    [TransferReason.Death]: "Death",
    [TransferReason.Divorce]: "Divorce",
    [TransferReason.DuplicateAccount]: "Duplicate account",
    [TransferReason.Other]: "Other",
};

export const ReducedReasonMap = {
    [TransferReason.NotSpecified]: "",
    [TransferReason.DuplicateAccount]: "Duplicate account",
    [TransferReason.Other]: "Other",
};

export const ReasonReverseMap = {
    0: TransferReason.NotSpecified,
    1: TransferReason.Death,
    2: TransferReason.Divorce,
    3: TransferReason.DuplicateAccount,
    4: TransferReason.Other,
};

export const ReducedReasonReverseMap = {
    0: TransferReason.NotSpecified,
    3: TransferReason.DuplicateAccount,
    4: TransferReason.Other,
};

export const WizardLabel = {
    selectSource: "Select Source:",
    reason: "Reason for moving holdings:",
    detail: "Details:",
    reference: "Reference:",
    InvestmentTable: {
        name: "Investment",
        value: "Value",
        quantity: "Available quantity",
        moveAll: "Move all available?",
        move: "Quantity",
    },
    investmentTablePP: {
        AmendBookCost: "Tax Book Cost",
        AcquisitionDate: "Valuation Date",
        CGT: "CGT Exempt?",
    },
    desAccountPopup: {
        title: "Search Criteria",
        accountName: "Account name:",
        accountNameTable: "Account name",
        clientforename: "Client forename:",
        clientsurname: "Client surname:",
        accountNum: "Account number:",
        accountNumTable: "Account number",
        status: "Status",
        adviser: "Adviser",
        search: "Search",
        select: "Select",
        remove: "Remove",
    },
    desAccountTitle: "Destination account details summary",
    desAccountTable: {
        name: "Name",
        accountNum: "Account number",
        type: "Account type",
        product: "Product",
    },
    pensionDetail: {
        Q1:
            "What is the cumulative total (if any) of the member's Standard Lifetime Allowance crystallised at the date of this application, by benefit crystallisation events under this scheme and any previous scheme from which the member's benefits have been transferred?",
        Q2: "Is there an earmarking or attachment order that applies to this transfer?",
        Q3: "Does this transfer form part of a block transfer?",
        Q4: "Does the member have 6 April 2006 protected tax-free lump sum rights?",
        Q5: "What is the protected amount at 5 April 2006?",
        Q6: "What was the fund value at 5 April 2006?",
        Q7: "Does the member have the right to benefits prior to age 55 under the transferring arrangement?",
        Q8: "To what age does this right apply?",
    },
    confirm: {
        title: "Declarations",
        label: "Please confirm the above by ticking the following box: ",
    },
};

export const errorStepOne = {
    detail: "Please enter Details",
    reason: "Please enter a reason for moving holdings",
    reference: "Please enter reference",
    required: "This field is requried",
    noInvesment: "No data against the selected account",
    noDesAccount: "Please specify a destination account",
    noInvestmentSelect: "Please choose a investment to transfer",
    decimal: "At most 4 decimal",
    wholeUnit: "only can move full units",
    atMost: "At most ",
    atLeast: "At least ",
};

export const submitErrorMessages = {
    [InterAccountTransferErrors.EmptyTransferAssets]: "Please choose a investment to transfer.",
    [InterAccountTransferErrors.InvalidTransferAccounts]:
        "Please make sure source account and destination account are of the same type.",
    [InterAccountTransferErrors.ModelDeconstructionOpenDeals]: "You can not transfer a model with open deals.",
    [InterAccountTransferErrors.MultipleModelMigrations]: "You can not transfer a model with pending migrations.",
    [InterAccountTransferErrors.InsufficientAssetToTransfer]: "Insufficient assets.",
};
